export default __webpack_public_path__ + "static/media/ambulo-logo-512x512-cherry-white.df3e61f3.svg";